// contexts/UserContext.js
import { createContext, useContext, useState, useEffect } from "react";
import AuthService from "../services/AuthService";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = async () => {
    setLoading(true);
    try {
      const userData = await AuthService.getUser(); // ✅ Fixed: userData is already the user object
      setUser(userData);
    } catch (error) {
      console.error("Failed to refresh user:", error);
      // Don't set user to null on error - keep current user data
      // This prevents logout when refresh fails
    } finally {
      setLoading(false);
    }
  };

  // Add this function to update user without full refresh
  const updateUser = (updatedFields) => {
    setUser((prev) => (prev ? { ...prev, ...updatedFields } : null));
  };

  useEffect(() => {
    refreshUser();
  }, []);

  const isLoggedIn = !!user && !loading;

  return (
    <UserContext.Provider
      value={{
        user,
        loading,
        refreshUser,
        setUser,
        updateUser, // ✅ Add this
        isLoggedIn,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
